import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-1" }

import { onMounted, ref } from 'vue'
import { useEventListener, useVModel } from '@vueuse/core'
import { PostedMessage, useH5Bridge, Method } from '@/utils/bridge'


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:modelValue', v: Set<string>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: Set<string>
}





const selected = useVModel(props, 'modelValue', emit)
let _postMessage: <T>(method: Method, body: T) => void

const insetIframe = ref<HTMLIFrameElement | null>(null)
onMounted(() => {
    if (insetIframe.value?.contentWindow) {
        const targetWindow = insetIframe.value?.contentWindow
        _postMessage = useH5Bridge(targetWindow).postMessage
    }
})

function syncSelectedUser() {
    _postMessage('selectUser', Array.from(selected.value))
}

expose({
    syncSelectedUser,
})

// 监听来自子窗口的'更改选中目标'行为
useEventListener('message', ({ data }: MessageEvent<PostedMessage<string | string[]>>) => {
    // 显示一个员工的详细资料
    if (data.method === 'selectUser') {
        if (typeof data.body === 'string') {
            selected.value.add(data.body)
        } else {
            selected.value = new Set(data.body)
        }
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      ref_key: "insetIframe",
      ref: insetIframe,
      src: "/oa/team/selector?type=multiple&excludeSelf=true",
      width: "100%",
      height: "494px",
      frameborder: "0"
    }, null, 512)
  ]))
}
}

})